import React from 'react';

const ItemGrid = React.forwardRef(function ItemGrid({
  children,
  className = '',
  columns = 5,
  fluid = false,
  gap,
  label,
  rows,
  slotSize,
  style,
  ...props
}, ref) {
  const safeColumns = Math.max(1, Number(columns) || 1);
  const safeRows = Math.max(0, Number(rows) || Math.ceil(React.Children.count(children) / safeColumns));
  return (
    <div
      aria-colcount={safeColumns}
      aria-label={label}
      aria-rowcount={safeRows}
      className={`pl-item-grid ${className}`.trim()}
      data-fluid={fluid || undefined}
      ref={ref}
      role="grid"
      style={{
        '--pl-item-grid-columns': safeColumns,
        ...(gap ? { '--pl-item-grid-gap': gap } : {}),
        ...(slotSize ? { '--pl-item-grid-slot-size': slotSize } : {}),
        ...style,
      }}
      {...props}
    >
      {children}
    </div>
  );
});

export default ItemGrid;
